exports.routes = {
    login: `/sign-in`,
    signup: `/sign-up`,
    providerRegister: `/provider/sign-up`,
    dashboard: `/provider/dashboard`,
    message: `/provider/message`,
    providerMessage: `/provider/message/id`,
    myJobs: `/provider/jobs`,
    paymentSuccess: `/provider/jobs/payment-success`,
    paymentError: `/provider/jobs/payment-error`,
    lockedJobs: `/provider/locked/jobs`,
    jobDetails: `/provider/job/info`,
    careNetwork: `/provider/care-network`,
    addPost: `/provider/care-network/job-post`,
    paymentPostSuccess: `/provider/care-network/job-post/payment-success`,
    paymentPostError: `/provider/care-network/job-post/payment-error`,
    postedJob: `/provider/care-network/posted-job`,
    careNetworkDetails: `/provider/care-network/info`,
    advertisement: `/provider/advertisement`,
    addAdvertisement: `/provider/advertisement/add`,
    advertisementPaymentSuccess: `/provider/advertisement/payment/success`,
    advertisementPaymentError: `/provider/advertisement/payment/error`,
    postedAdvertisement: `/provider/advertisement/posted`,
    advertisementDetails: `/provider/advertisement/info`,
    networkDirectory: `/provider/network-directory`,
    userDetail: `/provider/network-directory/info`,
    profile: `/provider/profile`,
    calendar: `/provider/calendar`,
    subscriptionPlan: `/provider/subscription-plan`,
    subscriptionPaymentSuccess: `/provider/subscription-plan/payment/success`,
    subscriptionPaymentError: `/provider/subscription-plan/payment/error`,
    newsletter: `/provider/newsletter`,
    aboutUs: `/provider/about-us`,
    privacyPolicy: `/provider/privacy-policy`,
    termsCondition: `/provider/terms-condition`,
    contactUs: `/provider/contact-us`,
    transactionList: `/provider/transaction-history`,
    matchedApplicant: `/provider/care-network/matched-applicant`,
    reviewList: `/provider/reviews`,

    expenseDashboard: `/provider/expenses/dashboard`,
    expenseCreate: `/provider/expenses/create`,
    expenseEdit: `/provider/expenses/edit`,
    expenseList: `/provider/expenses/listing`,
    budgetList: `/provider/expenses/budget/listing`,

    communityDashboard: `/provider/community/dashboard`,
    communitySuggested: `/provider/suggested/community`,
    communityFollowing: `/provider/community/following`,
    communityList: `/provider/community/list`,
    communityInfo: `/provider/community/info`,
    communityPostInfo: `/provider/community/post/info`,
    communityShareProfile: `/provider/community/share/profile`,
    
    careLoyalty: `/provider/care-loyalty`,
}